var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slot-picker-wrapper"},[_c('el-row',{attrs:{"gutter":12}},_vm._l((_vm.allTimeSlots),function(slot,slotIdx){return _c('el-col',{key:slotIdx,attrs:{"span":12}},[_c('div',{staticClass:"slot",class:{
          'slot-selected': _vm.selectedSlot === slot.time,
          'slot-unavailable': !slot.available,
        },on:{"click":function($event){_vm.analyticsTrackTimeSelectClick(); _vm.$emit('slot-selected', slot)}}},[_vm._v(" "+_vm._s(slot.time)+" ")])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }